/**
 * Created by superman on 17/2/16.
 * http配置
 */
// 存放公共方法，其他的放在page 各自的页面模块，同页面命名
import axios from 'axios'
// import jsonp from 'jsonp'
import qs from 'qs'
import jsonp from 'jsonp'
import Config from '../config/config.js'
import Cookie from 'js-cookie'
// import store from './store/store'
// import * as types from './store/types'
// import router from './router'

// axios 配置
axios.defaults.timeout = 300000;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.withCredentials = true;
// axios.defaults.baseURL = '/backend/';

// http request 拦截器
axios.interceptors.request.use(
    config => {
        // if (store.state.token) {
        //     config.headers.Authorization = `token ${store.state.token}`;
        // }
        let token = getCookie(Config.token_cookie_name);
        if (token) config.headers[Config.token_header_name] = token;
        return config;
    },
    err => {
        // return Promise.reject(err);
    });

// 获取参数
function getQueryParamByName (name, url) {
    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

// http response 拦截器
axios.interceptors.response.use(
    response => {
        if (response.data.errno == 302) {
            let currentLink = encodeURIComponent(window.location.href);
            let corpId = getQueryParamByName('corpId');
            // console.log('corpId', corpId);
            // if (corpId){
            //     // 跳转定制登录页面
            //     caslogin = Config.api_app_domain + '/customize/sso/getUrl?corpId=' + corpId + '&redirect=' + currentLink;
            //     window.location = caslogin
            //     return
            // }
            let hasParams=response.data.body.location.indexOf('?')!==-1;
            let caslogin = hasParams?response.data.body.location + '&redirect=' + currentLink:response.data.body.location + '?redirect=' + currentLink;
            // let caslogin = config.agh_cas_domin + '/backend/cas/api/checkLoginForward?redirect=' + currentLink;
            window.location = caslogin
            return
        }
        if(response.data.errno == 401){
            let currentLink = encodeURIComponent(window.location.href);
            let corpId = getQueryParamByName('corpId');
            // let caslogin = config.cas_domin + '?redirect=' + currentLink;
            // window.location = caslogin
            let caslogin,count;
            if(Cookie.get('loginCount')){
                count=Cookie.get('loginCount')
            }else{
                count=0;
            }
            count++;
            Cookie.set('loginCount',count);
            console.log('loginCount', count);
            //  else if (count>2 && corpId){
            //     // 跳转定制登录页面
            //     caslogin = Config.api_app_domain + '/customize/sso/getUrl?corpId=' + corpId + '&redirect=' + currentLink;
            // } else if (corpId){
            //     // 跳转定制登录页面
            //     caslogin = Config.api_app_domain + '/customize/sso/getUrl?corpId=' + corpId + '&redirect=' + currentLink;
            // }

            if(count>2 && !corpId){
                caslogin = Config.agh_cas_domin + '/backend/cas/api/checkLoginForward?redirect=' + currentLink;
            }else{
                caslogin = Config.cas_domin + '?redirect=' + currentLink;
            } 
            window.location = caslogin
            return
        }
        // serviceState == 0 服务不可用
        if(response.data.errno == 403){
            window.location = Config.apps_domain + '/m/#/serviceForbidden';
            return
        }
        if (response.data.errno == 410) {
            let msg=response.data.error
            let obj={
                code:410,
                msg:msg
            }
            if(window.HTTPSTATUS){
                window.HTTPSTATUS.$emit('HTTPSCODE',obj)
            }
            return
        }
        if (response.data.errno == 500) {
            let msg='系统繁忙，<br/>如多次重试仍无效，<br/>可致电客服热线 400-6033-334<br/><span class="errorInfo">编号['+response.data.error+']</span>'
            let obj={
                code:500,
                msg:msg
            }
            if(window.HTTPSTATUS){
                window.HTTPSTATUS.$emit('HTTPSCODE',obj)
            }
            return
        }
        //未登录
        if(Config.app_name === 'isoftstone' && response.data.errno == 100100003){
            let currentLink = encodeURIComponent(window.location.href);
            window.location.href = Config.apps_domain + '/acas/backend/cas/api/checkLoginForward?redirect=' + currentLink;
        }
        return response;
    },
    error => {
        // if (error.response) {
        //     switch (error.response.status) {
        //         case 401:
        //             // 401 清除token信息并跳转到登录页面
        //             store.commit(types.LOGOUT);
        //             router.replace({
        //                 path: 'login',
        //                 query: {redirect: router.currentRoute.fullPath}
        //             })
        //     }
        // }
        // console.log(JSON.stringify(error));//console : Error: Request failed with status code 402
        // return Promise.reject(error.response.data)
    });
const httpGet = (url, params) => {
    let t=Math.random();
    if(params){
        Object.assign(params,{t:t})//解决ie get请求缓存问题
    }
    
    return axios.get(url, { params: params })
}
const httpPost = (url, formData, qsParams) => {
    var url = url;
    if (qsParams) {
        url += '?' + qs.stringify(qsParams)
    }
    return axios.post(url, qs.stringify(formData))
}
const httpPostPayload = (url, formData, qsParams) => {
    var url = url;
    if (qsParams) {
        url += '?' + qs.stringify(qsParams)
    }
    // console.log(formData);
    return axios.post(url, formData)
}
const httpDelete=(url,params)=>{
    let t=Math.random();
    if(params){
        Object.assign(params,{t:t})//解决ie get请求缓存问题
    }
    return axios.delete(url, { params: params })
}
const httpPut = (url,formData)=> {
    let t = new Date().getTime();
    var url = url+'?t='+t;
    return axios.put(url,qs.stringify(formData))
}
const httpJsonp = (url, params, cb) => {
        var url = url;
        if (params) {
            url += '?' + qs.stringify(params)
        }
        console.log('httpJsonp url', url);
        return jsonp(url, null, cb)
    }
    // const httpJsonp=(url,params,cb)=>{

var getCookie = name => {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) {
        return unescape(arr[2]);
    } else {
        return null;
    }
}

export { httpGet, httpPost, httpPostPayload, httpJsonp ,httpDelete,httpPut}
